export const defaultBeforeRemoveAction: () => boolean = () => true;
